import { type CarrierDef } from '../common.js'
import { accountNumber, password } from '../internal.js'

const credentialTypes = [accountNumber, password, 'site-id'] as const

export type dhlcCredType = (typeof credentialTypes)[number]
export const dhlc: CarrierDef<dhlcCredType> = {
  name: 'DHL Express USA',
  scac: 'dhlc',
  credentialTypes,
  legacyCredMap: [
    ['password', 'password'],
    ['site-id', 'username'],
    ['account-number', 'ref1'],
  ],
  engineLayers: ['rating'],
}
